<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title">Murder<br/><em>in the</em><br/>Merchant City</h1>
<p class="author">Angus McAllister</p>
<p class="pub"><img alt="illustration" src="images/pub.png"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?57d7cb08